import { Component, OnInit } from '@angular/core';
import { BaseLeadsManagement } from '../baseLidsManagment';
import { CouponService } from 'app/core/services/coupon.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';
import { LoginService } from 'app/login/services/login.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app-state.index';

@Component({
  selector: 'app-lids-managment',
  templateUrl: './lids-managment.component.html',
  styleUrl: './lids-managment.component.scss'
})
export class LidsManagmentComponent extends BaseLeadsManagement implements OnInit{

   constructor(public localizationService: LocalizationService,public loginService: LoginService,public  store: Store<AppState>, public commonService: CommonService,public businessManagmentService:BusinessManagmentService) {
     super(businessManagmentService,loginService,store,localizationService,commonService)
   }
  ngOnInit(): void {
     this.init()
   }
   onLoadData(event) {
    this.request.Paging = event.Paging;
    this.loadLids();
   }
    
}
